import { Component, Inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
    PwaPushNotificationInstanceToken,
    PwaPushNotificationInterface,
} from '../../interfaces/pwa-push-notification.interface';
import { take } from 'rxjs';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { PwaPushNotificationsLocalStorageService } from '../../services/pwa-push-notification/pwa-push-notifications.local-storage.service';

@Component({
    selector: 'pace-core-subscribe-push-notification-visual-guide',
    templateUrl: './subscribe-push-notifications-visual-guide.component.html',
    styleUrls: ['./subscribe-push-notifications-visual-guide.component.scss'],
    standalone: true,
})
export class SubscribePushNotificationVisualGuideComponent {
    public subscriptionFailed = false;
    public permissionBlockedInBrowser = false;

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        @Inject(PwaPushNotificationInstanceToken)
        private readonly pwaPushNotificationService: PwaPushNotificationInterface,
        private readonly pwaPushNotificationsLocalStorageService: PwaPushNotificationsLocalStorageService,
    ) {
        this.pwaPushNotificationsLocalStorageService
            .savePwaPushNotificationsUserSettingsAsync({
                isUserSubscribed: false,
                hasUserBeenOfferedToSubscribe: true,
            })
            .catch((error) => {
                this.log.error(this.constructor.name, 'Failed to save push notification user settings', error);
            });
    }

    public triggerPushNotificationSubscribe(): void {
        this.subscriptionFailed = false;
        this.permissionBlockedInBrowser = false;

        this.pwaPushNotificationService
            .pushNotificationSubscribe()
            .pipe(take(1))
            .subscribe({
                next: (success) => {
                    if (success) {
                        this.log.debug('Subscribe Visual Guide: successfully subscribed to push notifications');
                        this.modalInstance.hide();
                    } else {
                        this.log.warn('Subscribe Visual Guide: failed to subscribe to push notifications');
                        this.reportFailure();
                    }
                },
                error: (error) => {
                    this.log.error(this.constructor.name, 'Error while subscribing to push notifications', error);
                    this.reportFailure();
                },
            });
    }

    /**
     * A browser that has explicitly denied notification permission will never show a fresh
     * permission prompt again — `Notification.requestPermission()` resolves to 'denied'
     * immediately, with no UI. That case needs a different message than a generic/transient
     * failure, since retrying from here can never succeed; only the browser's own site
     * settings can fix it.
     */
    private reportFailure(): void {
        this.subscriptionFailed = true;
        this.permissionBlockedInBrowser = 'Notification' in window && Notification.permission === 'denied';
    }
}
